var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VBtn",
    _vm._g(
      _vm._b(
        {
          class: _vm.$style.headerCartBtn,
          attrs: { flat: "", icon: "", color: "grey.lighten-3" }
        },
        "VBtn",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("div", { class: _vm.$style.headerCart }, [
        _c("svg", {
          directives: [{ name: "svg", rawName: "v-svg" }],
          class: _vm.$style.headerCartIcon,
          attrs: { symbol: "cart-icon-kiosk", size: "18" }
        }),
        _vm._v(" "),
        _c("span", { class: _vm.$style.cartBadge }, [
          _vm._v("\n      " + _vm._s(_vm.cartLength) + "\n    ")
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileCartButton.vue?vue&type=template&id=cbe30d98&
// module id = null
// module chunks = 